module.exports = __webpack_public_path__ + "static/media/Keqing.d063646e.png";